import React from 'react';
import { Carousel } from 'react-responsive-carousel';

import styles from './ImageGallery.module.scss';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

const ImageGallery = props => {
  const { images } = props;

  return (
    <div className={styles.bns3_lot_gallery_wrapper}>
      <div className={styles.bns3_lot_gallery}>
        {images && images.length > 0 ? (
          <Carousel className={styles.bns3_lot_gallery_root}>
            {images &&
              images.map(({ id, fileName, lotId }) => (
                <div
                  key={id}
                  className={styles.bns3_carousel_image_container}
                  style={{
                    backgroundImage: `url(${fileName})`,
                  }}
                >
                  <img src={fileName} alt={`lot-${lotId}`} className={styles.bns3_carousel_image} />

                  <div
                    style={{
                      backgroundImage: `url(${fileName})`,
                    }}
                    className={styles.bns3_gallery_image}
                  />
                </div>
              ))}
          </Carousel>
        ) : (
          <div className={styles.bns3_mock_photo} />
        )}
      </div>
    </div>
  );
};

export default ImageGallery;
